// In Header component:
import React, { useEffect, useState } from "react";
import { useUser } from "../../context/userContext";
import Popup from "../modal/YesNoPopup";
import HelpPopup from "../modal/HelpPopup";
import { GrWifi } from "react-icons/gr";
import { GrWifiLow } from "react-icons/gr";
import { BiWifiOff } from "react-icons/bi";
import { IoIosSend } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import { IoNotificationsOutline } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";
import OptionsPopup from "../modal/Options";
import NotificationPopup from "../modal/NotificationPopup";
import { useConnection } from "../../context/ConnectionContext";
import { useExam } from "../../context/ExamContext";
import { formatSecondGetTime } from "../../utils/formatSecondGetTime";
import { useCountdown } from "../../hooks/useCountdown";
import { ImClock } from "react-icons/im";
import { clearFinishedExamDataFromBrowser } from "../../services/examService";
import { useFinishSession } from "../../services/index";
import { useExamServerDataOperations } from "../../hooks/useExamServerDataOperations";
import { useSaving } from "../../context/SavingContext"; // adjust path

function Header() {
  const { user, loading } = useUser();
  const {
    timeLeft,
    isPractice,
    isRealExam,
    activeView,
    isDemoExam,
    examType,
    productType,
    updateStageTimeLeft,
    setIsManualSubmit,
    updateActiveView,
  } = useExam();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isInfoPopupOpen, setInfoPopupOpen] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showNotifPopup, setShowNotifPopup] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
  const { isSaving } = useSaving();
  const { isOnline, isSlow } = useConnection();
  const triggerServerDataUpdate = useExamServerDataOperations();
  const { triggerFinishSession, isLoadingFinishSession, errorFinishSession } =
    useFinishSession();

  const handleHelp = () => {
    setInfoPopupOpen(true);
  };

  const handleYes = () => {
    window.location.href = frontendUrl;
    setPopupOpen(false);
  };

  const handleExamSubmit = () => {
    const confirmed = window.confirm(
      "Are you sure you want to submit this section?"
    );
    if (!confirmed) return;

    if (!isRealExam && !(isPractice && activeView == "listening")) {
      triggerFinishSession();
    }
    setIsManualSubmit(true);
    triggerServerDataUpdate();
    // clearFinishedExamDataFromBrowser()
    // if (activeView == "listening") {
    //   updateActiveView("readingIntro")
    // }
    // else if (activeView == "reading") {
    //   updateActiveView("writingIntro")
    // }
    // else {
    //   updateActiveView("practiceFinished")
    // }
  };

  // Prevent accidental navigation away from exam
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const countingTimeLeft = useCountdown();

  return (
    <header className="header h-[60px]">
      {!loading && (
        <div className="flex justify-between items-center w-full">
          <div className="user-details leftSide flex" style={{ flex: 1 }}>
            <span className="userName">
              {isDemoExam
                ? "Demo User"
                : `${user?.firstName} ${user?.lastName}`}
            </span>
          </div>
          <div
            className="flex justify-center font-bold "
            style={{ flex: 0.5 }}
          ></div>
          <div className="flex justify-center font-bold " style={{ flex: 1 }}>
            {activeView && !activeView.includes("Intro") && (
              <span
                className="timer "
                onClick={() => setShowIcon((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                {
                  <div className="flex items-center gap-1.5">
                    <ImClock size={20} fontWeight="bold" />
                    <span className="text-[1.1rem] mt-[2px]">
                      {!showIcon && formatSecondGetTime(countingTimeLeft)}
                    </span>{" "}
                  </div>
                }
              </span>
            )}
          </div>

          <div className="flex justify-center font-bold " style={{ flex: 0.5 }}>
            {isSaving && (
              <div className="relative h-5 w-[100px] flex items-center justify-center">
                <div
                  className={`absolute flex items-center gap-2 text-sm text-orange-500 font-bold transition-opacity duration-500 ease-in-out ${isSaving ? "opacity-100 visible" : "opacity-0 invisible"
                    }`}
                >
                  <span className="w-4 h-4 border-2 border-t-transparent border-orange-500 rounded-full animate-spin"></span>
                  Saving...
                </div>
              </div>
            )}
          </div>

          <div
            className="rightSide flex items-center justify-end gap-2"
            style={{ flex: 1 }}
          >
            {([
              "reading",
              "listening",
              "writing",
            ].includes(productType)
              || examType == "free-practice")
              && ["reading", "listening", "writing"].includes(activeView) && (
                <button onClick={handleExamSubmit} className="submitBtn flex">
                  Submit
                  <IoIosSend className="submitIcon" />
                </button>
              )}
            <div className="header-buttons rightSideIcons flex items-center gap-2">
              <BiSupport onClick={handleHelp} />
              {isOnline ? <GrWifi /> : isSlow ? <GrWifiLow /> : <BiWifiOff />}
              <IoNotificationsOutline onClick={() => setShowNotifPopup(true)} />
              <GiHamburgerMenu onClick={() => setShowOptionsPopup(true)} />
            </div>
          </div>
        </div>
      )}

      <Popup
        isOpen={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        question="Are you sure you want to exit the exam?"
        subInfo="Your exam answers are saved. You will be able to resume the exam until its scheduled end time."
        onConfirm={handleYes}
      />

      <HelpPopup
        isOpen={isInfoPopupOpen}
        onClose={() => setInfoPopupOpen(false)}
        message="This is an informational message."
      />
      {showOptionsPopup && (
        <OptionsPopup onClose={() => setShowOptionsPopup(false)} />
      )}
      {showNotifPopup && (
        <NotificationPopup onClose={() => setShowNotifPopup(false)} />
      )}
    </header>
  );
}

export default Header;
